/**
 * Thin adapter: exposes SDK risk-analysis service (list UI removed; API may still be used).
 */
export class RiskAnalysisIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }
}
